var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.types.length > 0)?_c('div',{staticClass:"py-2"},_vm._l((_vm.types),function(type){return _c('batch-uploader',{key:type,staticClass:"mt-2",attrs:{"type":type},model:{value:(_vm.segmentedFiles[type]),callback:function ($$v) {_vm.$set(_vm.segmentedFiles, type, $$v)},expression:"segmentedFiles[type]"}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }